import { z } from 'zod';
import { NumberFormatting } from '@mews-framework/globalization';
import { NumberService } from '@mews-framework/services';
import { createCultureFormatRegex } from '../cultureFormatRegex';
import { CustomErrorParams, CustomErrorType } from '../CustomErrorType';
import { MAX_READABLE_DECIMAL } from './constants';

export const maxNonNegativeIntegerSchema = z.coerce.number().int().min(0).max(MAX_READABLE_DECIMAL);
export const maxPositiveIntegerSchema = z.coerce.number().int().min(1).max(MAX_READABLE_DECIMAL);

export const percentageSchema = z.number().min(0).max(100);

export const createLocalizedNumberSchema = (numberLocalizationInfo: NumberFormatting) =>
    z
        .number()
        .or(z.string().transform((value) => NumberService.unformat(value, numberLocalizationInfo)))
        .refine((value) => !Number.isNaN(value), {
            params: { errorType: CustomErrorType.FormattedNumber } satisfies CustomErrorParams,
        });

export const createLocalizedCurrencyNumberSchema = (numberLocalizationInfo: NumberFormatting) => {
    const cultureFormatRegex = createCultureFormatRegex(numberLocalizationInfo);
    return z.number().or(
        z
            .string()
            .refine((v) => cultureFormatRegex.test(v), {
                params: { errorType: CustomErrorType.FormattedNumber } satisfies CustomErrorParams,
            })
            .transform((value) => NumberService.unformat(value, numberLocalizationInfo))
            .refine((value) => !Number.isNaN(value), {
                params: { errorType: CustomErrorType.FormattedNumber } satisfies CustomErrorParams,
            })
    );
};
